// REST helpers. Mutating requests carry the anti-forgery token rendered
// into the hidden #__af form by the layout.

export async function getJson<T>(url: string): Promise<T> {
  const response = await fetch(url, { headers: { Accept: 'application/json' } });
  if (!response.ok) throw new Error(`GET ${url} failed: ${response.status}`);
  return (await response.json()) as T;
}

export async function postJson<T>(url: string, body: unknown): Promise<{ ok: boolean; status: number; data: T }> {
  const response = await fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      RequestVerificationToken: antiForgeryToken(),
    },
    body: JSON.stringify(body),
  });
  const data = (await response.json().catch(() => null)) as T;
  return { ok: response.ok, status: response.status, data };
}

function antiForgeryToken(): string {
  const input = document.querySelector<HTMLInputElement>('#__af input[name="__RequestVerificationToken"]');
  return input?.value ?? '';
}
